<template lang="html">
  <div id="wcc-app" class="unsupported">
    <div id="wcc-wrapper">
      <h1>Update Your Browser</h1>
      <p>To use Fee Calculator, please get the latest version of one of the following browsers.</p>
      <a rel="noopener noreferrer" target="_blank" href="https://www.google.com/chrome/">
        <img src="@/assets/chrome.png" alt="Chrome Logo">
      </a>
      <a rel="noopener noreferrer" target="_blank" href="https://www.mozilla.org/en-CA/firefox/">
        <img src="@/assets/firefox.png" alt="Firefox Logo">
      </a>
      <a rel="noopener noreferrer" target="_blank" href="https://www.apple.com/ca/safari/">
        <img src="@/assets/safari.png" alt="Safari Logo">
      </a>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>
<style lang="scss">
  #wcc-app.unsupported {
    #wcc-wrapper {
      text-align: center;
      > * {
        margin: $spacing 0;
      }
      a {
        img {
          width: 20%;
          margin: 0 $spacing/4;
        }
      }
    }
  }
</style>